import React, { useState } from 'react';
import { Grid, TextField, Card, CardContent, Typography, Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Stack from '@mui/material/Stack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function Document({ formData, handleFormDataChange, setValue }) {
    const [fileNames, setFileNames] = useState({});

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleFileChange = (field) => async (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileNames(prev => ({
                ...prev,
                [field]: file.name
            }));

            try {
                const base64 = await convertToBase64(file);
                handleFormDataChange('documents', {
                    ...formData.documents,
                    [field]: base64,
                    [`${field}_path`]: getDocumentPath(field)
                });
            } catch (error) {
                console.error('Error converting file:', error);
            }
        }
    };


    const getDocumentPath = (field) => {
        const pathMap = {
            'aadhar_file': 'documents/aadhar',
            'pan_file': 'documents/pan',
            'passport_file': 'documents/passport',
            'transfer_letter': 'documents/transfer',
            'offer_letter': 'documents/offer',
            'resume': 'documents/resume',
            'pay_slip': 'documents/pay_slip'
        };
        return pathMap[field] || '';
    };

    const handleAadharNumberChange = (event) => {
        handleFormDataChange('documents', {
            ...formData.documents,
            aadhar_num: event.target.value
        });
    };

    const handlePassportValidityChange = (event) => {
        handleFormDataChange('documents', {
            ...formData.documents,
            passport_valid_upto: event.target.value
        });
    };
    const handleNext = () => {
        setValue('Education');
    };

    const documentFields = [
        { name: 'aadhar_filename', label: 'Aadhar Card', hasNumber: true },
        { name: 'pan_filename', label: 'PAN Card' },
        { name: 'passport_file', label: 'Passport', hasValidity: true },
        { name: 'transfer_letter', label: 'Transfer Letter' },
        { name: 'offer_letter', label: 'Offer Letter' },
        { name: 'resume', label: 'Resume' },
        { name: 'payslip_filename', label: 'Pay Slip' }
    ];

    return (
        <Card sx={{ margin: 2 }}>
            <CardContent>
                <Typography color="#1976d2" gutterBottom sx={{ fontSize: '20px', marginBottom: '20px' }}>
                    <strong style={{ fontWeight: 600 }}>Documents</strong>
                </Typography>
                <Grid container spacing={5.5}>
                    {documentFields.map((field) => (
                        <React.Fragment key={field.name}>
                            {field.hasNumber && (
                                <Grid item xs={12} sm={6} md={6} lg={4}>
                                    <TextField
                                        // required
                                        label="Aadhar Number"
                                        name="aadhar_num"
                                        value={formData.documents?.aadhar_num || ''}
                                        onChange={handleAadharNumberChange}
                                        InputLabelProps={{ shrink: true }}
                                        size='small'
                                        sx={{
                                            width: "100%",
                                        }}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                <input
                                    type="file"
                                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    onChange={handleFileChange(field.name)}
                                    style={{ display: 'none' }}
                                    id={field.name}
                                />
                                <label htmlFor={field.name}>
                                <Button
                                    variant="outlined"
                                    component="span"
                                    startIcon={<CloudUploadIcon />}
                                    size="medium"
                                    sx={{
                                        width: "100%",
                                        padding: '7px 0px',
                                        textTransform: 'none',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                    }}
                                    >
                                    <span
                                        style={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        display: 'inline-block',
                                        maxWidth: '100%',
                                        textAlign: 'center',
                                        }}
                                        title={formData.documents?.[field.name] || fileNames[field.name] || `Upload ${field.label}`}
                                    >
                                        {formData.documents?.[field.name] || fileNames[field.name] || `Upload ${field.label}`}
                                    </span>
                                    </Button>

                                </label>
                                {formData.documents?.[field.name] && (
                                    <Typography
                                        variant="caption"
                                        display="block"
                                        sx={{
                                            mt: 1,
                                            color: 'green'
                                        }}
                                    >
                                        File saved successfully
                                    </Typography>
                                )}
                            </Grid>
                            {field.hasValidity && (
                                <Grid item xs={12} sm={6} md={6} lg={4}>
                                    <TextField
                                        // required
                                        label="Passport Valid Upto"
                                        type="date"
                                        name="passport_valid_upto"
                                        value={formData.documents?.passport_valid_upto || ''}
                                        onChange={handlePassportValidityChange}
                                        InputLabelProps={{ shrink: true }}
                                        size='small'
                                        sx={{
                                            width: "100%",
                                            "& .MuiInputBase-input": {
                                                color: formData.documents?.passport_valid_upto ? "#000" : "#a2a2a2", // Black when input is given, Gray otherwise
                                            },
                                            "& input::-webkit-datetime-edit-text": {
                                                color: "#a2a2a2", // Ensures placeholder ("dd-mm-yyyy") is gray
                                            },
                                            "& input::-webkit-datetime-edit-year-field, \
                                               & input::-webkit-datetime-edit-month-field, \
                                               & input::-webkit-datetime-edit-day-field": {
                                                color: formData.documents?.passport_valid_upto ? "#000" : "#a2a2a2", // Black when selected, Gray when empty
                                            }
                                        }}
                                    />
                                </Grid>

                            )}
                        </React.Fragment>
                    ))}
                    <Grid item xs={12} sx={{ height: "80px", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                        <Stack direction="row" spacing={2}>
                            <Button
                                variant="contained"
                                endIcon={<ArrowForwardIcon />}
                                onClick={handleNext}
                            >
                                Next
                            </Button>
                        </Stack>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default Document;